"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _modalLoaderUtils = require("@wsb/modal-loader-utils");
var ml = _modalLoaderUtils.CONSTANTS.LOADER_NAMESPACE;
var snakeToCamel = _modalLoaderUtils.HELPERS.snakeToCamel;

// This function assigns 'ml' as a property of 'window'
// which consists of an object containing the modal's appConfig,
// deps, i18n and the boolean of scriptLoaded
var _default = exports.default = function _default(namespace) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var ns = snakeToCamel(namespace);
  var keys = [ml, ns];
  key && keys.push(key);
  return keys.reduce(function (data, name) {
    if (!data[name]) {
      data[name] = {};
    }
    return data[name];
  }, window);
};